var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetooth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "30px",
    height: "48px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAwCAQAAACsnwJvAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoAhUUFSrc5ePsAAABLElEQVRIx63WzW3DMAwF4IcsYG3QbtCMkE0zQpEJigK5C55A2eT1UCP6e1QoKNbFsPUZMk2RBmEPJKQQYzDvv8AEbe7ANndhizux5m6s+ATuOQgihuvFg1sOIoYQkRTvcc3/KUHFnzh93VTkcVDJMyYUx/VSLK7hJVYcHPAa9xwc8BYTH79l6I4zzVvcznqeK17jfkYRHnGzwPLhHPCMjdeizfUoA8o5Xn9KzvA2iejnffrSy9XGoc2rC2rLnrByvH3ZCwFb+FQLSbKQngsbY7wlCdzxqPmA9pUE9+bhNlU1TJQhfwH8/Mnvue2YKb3n7zxz22OYKPotJbDtg/QrcE8JxHDwYaNT9Gix2+5vsZlON/eSTv5W1HQKt3QC99SNFXViTV3Yoq9xsinxB2SyWW3MKFyKAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.3429d7b2b8fef031b8e1fd9053c55e3e.svg";
export { ForwardRef as ReactComponent };